class HeaderMenu {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
    });

    $('.s-nav a').click(function () {
      $('html').removeClass('is-open');
    });
  }
}
